import type {
  EmailEventInput,
  EmailEventPreview,
  EmailEventResult,
  EmailEventSource,
  EmailEventSuggestion,
} from "@shared/emailCalendar";
import { api } from "@web/lib/api";
export const emailCalendarApi = {
  source: (threadKey: string) =>
    api<EmailEventSource>(
      `/api/calendar/email-events/source?${new URLSearchParams({ threadKey })}`,
    ),
  suggest: (messageKey: string) =>
    api<EmailEventSuggestion[]>("/api/calendar/email-events/suggest", {
      method: "POST",
      body: { messageKey },
    }),
  preview: (event: EmailEventInput) =>
    api<EmailEventPreview>("/api/calendar/email-events/preview", { method: "POST", body: event }),
  approve: (event: EmailEventInput, fingerprint: string) =>
    api<EmailEventResult>("/api/calendar/email-events/approve", {
      method: "POST",
      body: { event, fingerprint },
    }),
};
/**
 * A suggestion response belongs to the email it was asked for. When the owner has since picked
 * another source email, the late response is dropped (null) so it cannot fill the new form.
 */
export function currentSuggestions<T>(requestedKey: string, selectedKey: string, list: T[]) {
  return requestedKey === selectedKey ? list : null;
}
/** UI dates include the last day; Calendar stores the exclusive end of an all-day event. */
export function nextDate(date: string): string {
  const d = new Date(`${date}T00:00:00Z`);
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(date) ||
    !Number.isFinite(d.getTime()) ||
    d.toISOString().slice(0, 10) !== date
  )
    return "";
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
}
